import Hail from './Hail.png'
import Clear from './Clear.png'
import HeavyCloud from './HeavyCloud.png'
import HeavyRain from './HeavyRain.png'
import LightCloud from './LightCloud.png'
import LightRain from './LightRain.png'
import Shower from './Shower.png'
import Sleet from './Sleet.png'
import Snow from './Snow.png'
import Thunderstorm from './Thunderstorm.png'

const weatherStatesImages = {
    "Snow" : Snow,
    'Sleet' : Sleet,
    'Hail' : Hail,
    'Thunderstorm' : Thunderstorm,
    'Heavy Rain' : HeavyRain,
    'Light Rain' : LightRain,
    'Showers' : Shower,
    'Heavy Cloud' : HeavyCloud,
    'Light Cloud' : LightCloud,
    'Clear' : Clear
}

export default weatherStatesImages;